import { addDays, differenceInCalendarDays } from 'date-fns'
import { sortedLastIndexBy } from 'lodash'
import drawEvent from './drawEvent'

export default (
  ctx,
  constants,
  cHeight,
  cWidth,
  rooms,
  dateStart,
  startRoomIdx,
  shape,
  colors,
  eventLabels,
  fromX,
  toX,
  fromY,
  toY,
  doLabel,
  isPrice = false,
  showOriginIcon = false,
) => {
  let createdLabels = {}
  const roomsShown = rooms.slice(
    startRoomIdx,
    startRoomIdx + Math.ceil(cHeight / constants.GRID_HEIGHT),
  )

  let drawedEvents = []
  for (let j = fromY; j < toY; j++) {
    const room = roomsShown[j]

    if (!room) continue
    if (!room.events || room.events.length === 0) continue

    let i = fromX - 1
    while (i < toX) {
      const dateShown = addDays(dateStart, i)
      const evIndex = sortedLastIndexBy(
        room.events,
        { startDate: dateShown },
        re => {
          return re.startDate.getTime()
        },
      )

      const ev = room.events.slice(evIndex - 1, evIndex).find(event => {
        return dateShown >= event.startDate && dateShown <= event.finishDate
      })

      if (ev && !drawedEvents.includes(ev.id)) {
        let x =
          differenceInCalendarDays(ev.startDate, dateStart) *
            constants.GRID_WIDTH +
          (constants.GRID_WIDTH - constants.EVENT_GAP) / 2
        if (shape === 'diamond') {
          x -= constants.EVENT_DIAMOND_SLOPE / 2
        }
        const y =
          j * constants.GRID_HEIGHT +
          (constants.GRID_HEIGHT - constants.EVENT_HEIGHT) / 2
        const width =
          differenceInCalendarDays(ev.finishDate, ev.startDate) *
            constants.GRID_WIDTH -
          constants.EVENT_GAP
        const height = constants.EVENT_HEIGHT

        if (width > 0 && height > 0) {
          drawedEvents.push(ev.id)
          const createdLabel = drawEvent(
            ctx,
            constants,
            x,
            y,
            width,
            height,
            shape,
            colors,
            ev,
            eventLabels,
            false,
            doLabel,
            isPrice,
            showOriginIcon,
          )

          if (createdLabel) {
            createdLabels = {
              ...createdLabels,
              ...createdLabel,
            }
          }
        }
        i += differenceInCalendarDays(ev.endDate, dateShown) || 1
      } else {
        i++
      }
    }
  }

  return createdLabels
}
